// Typed admin API client, built from the shared route registry.
//
// CLIENT-SIDE use (hooks / components) — issues relative-URL fetches, so it must
// run in the browser, not in a server route handler. New code calls
// `api.<resource>.<sub>.<verb>(...)` instead of hand-writing `fetch('/api/...')`;
// the registry types the path + params + verbs and the parity test keeps the URL
// in sync with the route folders. Existing inline fetch sites migrate here on
// touch (see plans/typesafe-api-url-registry-06-22-26.md).

import { createApiClient } from '@auctogon/core/api/registry';
import { adminRegistry } from '@auctogon/core-admin/api-registry';
import { apiFetch } from './offline-transport/offline-routing';
import { handleAdminUnauthorized } from './unauthorized-redirect';

export const api = createApiClient(adminRegistry, {
  init: { credentials: 'same-origin' }, // send the staff-session cookie
  // BL-2343 (ADR 066 — Offline Mode § 3): the network, or, while the phone app is offline, the
  // offline transport over the device store. Resolved per call.
  fetch: apiFetch,
  // Stale/expired staff session (401) -> route to sign-in instead of a raw
  // "Unauthorized" error (BUG-802, RAC 3).
  onUnauthorized: handleAdminUnauthorized,
});
